/* app/GuestOnlyRoute.jsx — HOC гостевой зоны (S12).
   Прод-поведение: авторизованного пользователя уводит на /chat (нечего делать на /signin).
   Прототип: чтобы ВСЕ гостевые экраны открывались по deep-link для приёмки (а демо-юзер
   авторизован по умолчанию, см. AuthProvider), редирект отключён флагом PROTOTYPE_PREVIEW.
   ХЕНДОФФ → frontend/src/app/GuestOnlyRoute.jsx: снять флаг, оставить активным редирект. */

import { useAuth } from './providers/AuthProvider.jsx';
import { RR } from '../lib/router.jsx';

  const { Navigate } = RR;

  // В боевом приложении = false (редирект работает). В прототипе = true (экраны видимы).
  const PROTOTYPE_PREVIEW = true;

  function GuestOnlyRoute({ children }) {
    const { user } = useAuth();
    if (user && !PROTOTYPE_PREVIEW) return <Navigate to="/chat" />;
    return children;
  }

export { GuestOnlyRoute };
